import {getOrdinal} from "../builder/AuctionStatusView";
import {Badge} from "../ui/badge";

/**
 * this will likely expand to a few different types of feedback so separating it out.
 * */
export function rankBadge(rank:number){
    if(rank) {
        let ord = getOrdinal(rank);
        return <Badge variant="outline">{rank}{ord}</Badge>
    }
}